export default __webpack_public_path__ + "static/media/25Dimic.3af95219.jpg";